// extracted by mini-css-extract-plugin
export default {"characteristics":"styles_characteristics__R0TxK"};